import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { MdIvesCondition, MdIvesMdlInfo, MdIvesPrjInfo } from 'models/md/MdIves';
import { callApi } from 'utils/ApiUtil';

/**
 * 형개발 투자비 산출 목록
 * @param condition
 * @returns
 */
export const findMdIvesList = async (condition: MdIvesCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<MdIvesPrjInfo[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdIvesPrjInfo[];
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 정보 등록
 * @param masterData
 * @returns
 */
export const saveMdPrjInfo = async (masterData: MdIvesPrjInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/project`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: masterData,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 프로젝트 정보 조회
 * @param elmPrjId
 * @returns
 */
export const findMdPrjInfo = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/invest/project/${elmPrjId}`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<MdIvesPrjInfo> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 형개발 투자비 INPUT 복사
 * @param masterData
 * @returns
 */
export const copyMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/copy`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 상태 변경 > 완료
 * @param masterData
 * @returns
 */
export const completeMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/complete`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 상태 변경 > drop
 * @param masterData
 * @returns
 */
export const dropMdIves = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/invest/${elmPrjId}/drop`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 형개발 투자비 산출 등록 > 형개발 투자비 INPUT > 모델사양정보 저장
 * @param masterData
 * @returns
 */
export const saveMdIvesMdlInfo = async (mdlInfo: MdIvesMdlInfo) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/model`,
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};
